export default __webpack_public_path__ + "static/media/typescript.606d2171.svg";